import { Component} from '@angular/core';
import { GlobalService } from 'src/app/api/global.service';
import { ActivatedRoute, Router } from '@angular/router';
import * as _ from 'underscore';
import {
  FormBuilder,
} from '@angular/forms';
import { environment } from 'src/app/environment';
import AlertifyHelper from 'src/app/utils/utils';
import { NavigationTrackerService } from 'src/app/utils/navigation-tracker.service';
import { ToolsService } from 'src/app/utils/tools.service';
import { BookingsService } from 'src/app/api/booking/bookings.service';
import SwalAlert from 'src/app/utils/swalalert';import { constants } from 'src/app/constants';
declare var $: any;

@Component({
  selector: 'app-transfers-detail',
  templateUrl: './transfers-detail.component.html',
  styleUrls: ['./transfers-detail.component.css']
})
export class TransfersDetailComponent {

  branchofficeSlug: string = '';
  nameMenu: string = 'gallery_image';
  checkId: number;
  book: any = null ;
  submitted: boolean = false;
  txtSubmenu: string = environment.txt_create_menu_form;
  isEdit: boolean = false;

 
  // arrays
  bookingSelected:any = null;
  tours:any = [];

  constructor(
    public fb: FormBuilder,
    private router: Router,
    private routeActivated: ActivatedRoute,
    private globalService: GlobalService,
    private bookingsService: BookingsService,
    private navigationTrackerService: NavigationTrackerService,
    private alertifyMsg: AlertifyHelper,
    public toolsService: ToolsService,
    private alert: SwalAlert,
  ) {
    this.branchofficeSlug = this.globalService.slugBranchoffice;
    this.checkId = this.routeActivated.snapshot.params['id'];
    if (!_.isUndefined(this.checkId)) {
      this.txtSubmenu = environment.txt_edit_menu_form;
      this.isEdit = true;
    }
  }

  ngOnInit() {
    this.navigationTrackerService.initializeMenu(this.routeActivated);
    if (this.isEdit) {
      this.editData();
    }
    (<any>$('[data-toggle="tooltip"]')).tooltip();
  }

  editData(check_id=null) {
    this.bookingsService.getTransferData(this.checkId).subscribe({
      next: (data: any) => {
        let result = data.data;
        this.book = result.book;
        this.bookingSelected = this.book.origintransfer;
        this.tours = this.book.program_transfer;
      }
    });
  }

  beforeAmortization(data:any){
    this.editData();
  }

  edit(id: number) {
    this.router.navigate([
      this.branchofficeSlug + '/reservas/traspasos/editar',
      id
    ]);
  }

  printer(){
    (<any>$('#body')).printThis({
      importCSS: true,
  });
  }

  delete(item: any) {
    let options = {
      title: '¿Estás segur@?',
      message: " de Traspaso "+item.code,
      cancel: 'Cancelar',
      confirm: 'Eliminar'
    };
    this.alert.confirmDelete(options).then((result: any) => {
      if (result.isConfirmed) {
        this.bookingsService.deleteTransfers(item.id).subscribe({
          next: (data: any) => {           
            this.alertifyMsg.success('El registro '+item.code+' se ha eliminado con éxito');
            this.cancel();
          }
        });
      }
    });
  }

  cancel() {
    this.router.navigate([
      this.branchofficeSlug + '/reservas/traspasos/lista'
    ]);
  }

}
